<template>
  <div>
    <div ref="detailsWindow" class="detailsWindow card" v-show="track.maximized">
      <div ref="detailsWindowHeader" class="detailsWindowHeader card-header" style="width: 500px; max-width: 500px;">
        <span va-b-tooltip.hover :title="$t('centerTrack')">
          <img @click="centerTrack" style="height: 24px; cursor: pointer;" :src="icons.center" />
        </span>&nbsp;
        <span v-if="($store.state.user) && (window.isDesktop)">
          <span v-if="track.onServer" va-b-tooltip.hover :title="$t('saveTrack')">
            <img @click="showUploadModal" style="height: 20px; cursor: pointer;" :src="icons.save" />
          </span>
          <span v-else va-b-tooltip.hover :title="$t('uploadTrack')">
            <img @click="showUploadModal" style="height: 20px; cursor: pointer;" :src="icons.upload" />
          </span>
          <span style='margin-right: 3px;'></span>
        </span>
        
        <div style="display: inline" class="custom-control custom-checkbox" :id="'detailstrackcheckbox' + track.gpsTrack.id">
          <b-form-checkbox style="margin-right: 2px;" class="display-inline" :id="'detailscheckbox' + track.gpsTrack.id" v-model="track.checked">
          </b-form-checkbox>
          <label style="margin-right: 2px;" class="custom-control-label" :for="'detailscheckbox' + track.gpsTrack.id">{{ track.gpsTrack.name }}</label>
        </div>
        <span class="badge bg-dark" style="margin-right: 2px; margin-left: 2px;">{{ formatDateDay(track.gpsTrack.start_time) }}</span>
        <span :class="getDisanseBadgeClasses(track.gpsTrack)" style="margin-right: 2px;">{{ roundTrackDistance(track.gpsTrack.distance) }}</span>
        <span v-if="track.gpsTrack.elevation_gain !== null" :class="getElevationGainBadgeClasses(track.gpsTrack)">{{ track.gpsTrack.elevation_gain }} m</span>
        <div style="float: right;">
          <img @click="toggleMaximizedDetails" style="height: 13px; cursor: pointer;" :src="maximizedDetails ? icons.chevronUp : icons.chevronDown" />&nbsp;
          <img @click="track.maximized = false" style="height: 20px; cursor: pointer;" :src="icons.closeIcon" />
        </div>
      </div>
      <div v-show="maximizedDetails" ref="maximizedBody" class="card-body" style="max-width: 500px;">
        <span style="text-align: center" v-if="trackDetailsLoading">
          <img style='height: 32px; animation: rotation 2s infinite linear;' v-if="trackDetailsLoading" :src="icons.spinnerBlack" />&nbsp;
        </span>
        <div v-else>
          <b>{{ $t('name') }}</b>: {{ track.gpsTrack.name }}<br>
          <span v-if="track.gpsTrack.description"><b>{{ $t('description') }}</b>: {{ track.gpsTrack.description }}<br></span>
          <b>{{ $t('startTime') }}</b>: {{ formatDate(track.gpsTrack.start_time) }}, <span v-if="track.gpsTrack.start_time">{{ $t(dayIndex(track.gpsTrack.start_time)) }}</span><br>
          <b>{{ $t('distance') }}</b>: {{ roundTrackDistance(track.gpsTrack.distance) }}<br>
          <span style="margin-right: 30px;"><b>{{ $t('id') }}</b>: {{ track.gpsTrack.id }}</span>
          <span style="margin-right: 30px;" v-if="track.onServer"><b>{{ $t('type') }}</b>: <TrackTypeIcon :gpsTrack="track.gpsTrack" height=12 imgheight=12 verticalAlign="-2px"></TrackTypeIcon></span>
          <span style="margin-right: 30px;" v-if="track.onServer"><b>{{ $t('status') }}</b>: <TrackStatusIcon :gpsTrack="track.gpsTrack" height=12></TrackStatusIcon></span>
          <button type="button" class="btn btn-primary btn-sm" style="margin-left: 8px;" @click="showWeatherModal">Pogoda</button>
          <br>
          <span ref="gallerySpan"/>
          <b>{{ $t('photosAndMovies') }}</b>: 
            {{ track.gpsTrack.photos.length }}<img v-if="track.gpsTrack.photos.length" @click="(event) => openTrackGallery(event, track, 0)" style="height: 20px; cursor: pointer;" :src="icons.images" />&nbsp;
            {{ track.gpsTrack.videos.length }}<img v-if="track.gpsTrack.videos.length" @click="openTrackVideos(track)" style="height: 20px; cursor: pointer;" :src="icons.video" /><br>
          <span v-if="track.gpsTrack.gpx_file" style="margin-bottom: 5px; margin-right: 8px;"><b>{{ $t('gpxFile') }}: </b>{{ roundFileBytes(track.gpsTrack.gpx_file.length) }} <button @click="saveGPX" type="button" class="btn btn-primary btn-sm">Download</button></span>
          <span v-if="track.gpsTrack.json_file" style="margin-bottom: 5px;"><b>{{ $t('jsonFile') }}: </b>{{ roundFileBytes(track.gpsTrack.json_file.length) }} <button @click="saveJSON" type="button" class="btn btn-primary btn-sm">Download</button></span>
          <template v-if="track.gpsTrack.json_file"><a target="_blank" :href="'/trackanalyze/'+ track.gpsTrack.id + '/'" class="btn btn-primary btn-sm" style="margin-bottom: 3px; margin-right: 20px;">{{ $t('analyzeTrack') }}</a></template>
          <template v-if="track.gpsTrack.gpx_file"><button style="margin-right: 20px;" @click="colorTrackBySpeed" type="button" class="btn btn-primary btn-sm">{{ speedTrackVisible ? $t('hideSpeedTrack') : $t('showSpeedTrack') }}</button></template>
          <button v-if="track.gpsTrack.json_file" @click="toggleJSONPush" type="button" style="margin-right: 20px;" class="btn btn-primary btn-sm">{{ jsonPushVisible ? $t('hidePush') : $t('showPush') }}</button>
          
          <div style="vertical-align: middle; display: inline-block;">
            <div style="display: inline" class="custom-control custom-checkbox" :id="'debug' + track.gpsTrack.id">
              <b-form-checkbox style="margin-right: 2px; margin-top: 3px" class="display-inline" :id="'debugcheckbox' + track.gpsTrack.id" v-model="debug">
              </b-form-checkbox>
              <span style="cursor: default" @click="debug = !debug">{{ $t('debug') }}</span>
            </div>
          </div>

          <dev v-if="debug">
            <b>{{ $t('points') }}</b>: {{ track.gpsTrack.countPointsOptimized() }}<br>
            <template v-if="track.gpsTrack.gpx_file"><button style="margin-right: 3px" @click="showHideTimeLables" type="button" class="btn btn-primary btn-sm">{{ timeLabelsVisible ? $t('hideTimeLabels') : $t('showTimeLabels') }}</button></template>
            <template v-if="track.gpsTrack.gpx_file"><button style="margin-right: 3px" @click="showHideSpeedLables" type="button" class="btn btn-primary btn-sm">{{ speedLabelsVisible ? $t('hideSpeedLabels') : $t('showSpeedLabels') }}</button></template>
            <template v-if="track.gpsTrack.gpx_file"><button style="margin-right: 3px" @click="toggleGPX" type="button" class="btn btn-primary btn-sm">{{ gpxVisible ? $t('hideGPX') : $t('showGPX') }}</button></template>
            <template v-if="track.gpsTrack.json_file"><button style="margin-right: 3px" @click="toggleJSON" type="button" class="btn btn-primary btn-sm">{{ jsonVisible ? $t('hideJSON') : $t('showJSON') }}</button></template>
          
            <div v-if="gpxVisible" style="display: flex; margin-top: 10px; margin-right: 20px;">
              <span :id="'gpxColor1' + track.gpsTrack.id" style="display:inline-block; width:20px; height:20px; border-radius:50%; cursor:pointer; margin-right:6px;" :style="{ 'background-color': getColorHex(gpxColor1) || track.gpsTrack.color }"></span>
              <b-popover :target="'gpxColor1' + track.gpsTrack.id" triggers="focus" placement="top" :delay="{ 'show': 0, 'hide': 0 }">
                <SketchPicker v-model="gpxColor1" :disableAlpha="true" :disableFields="true"></SketchPicker>
              </b-popover>

              <span :id="'gpxColor2' + track.gpsTrack.id" style="display:inline-block; width:20px; height:20px; border-radius:50%; cursor:pointer; margin-right:6px;" :style="{ 'background-color': getColorHex(gpxColor2) || track.gpsTrack.color }"></span>
              <b-popover :target="'gpxColor2' + track.gpsTrack.id" triggers="focus" placement="top" :delay="{ 'show': 0, 'hide': 0 }">
                <SketchPicker v-model="gpxColor2" :disableAlpha="true" :disableFields="true"></SketchPicker>
              </b-popover>

              <span :id="'gpxColor3' + track.gpsTrack.id" style="display:inline-block; width:20px; height:20px; border-radius:50%; cursor:pointer; margin-right:6px;" :style="{ 'background-color': getColorHex(gpxColor3) || track.gpsTrack.color }"></span>
              <b-popover :target="'gpxColor3' + track.gpsTrack.id" triggers="focus" placement="top" :delay="{ 'show': 0, 'hide': 0 }">
                <SketchPicker v-model="gpxColor3" :disableAlpha="true" :disableFields="true"></SketchPicker>
              </b-popover>

              <label style="margin-left:6px; margin-right:3px;">
                <b-form-checkbox style="margin-right: 2px; margin-top: 3px" class="display-inline" v-model="gpxShowMarkers">
                </b-form-checkbox>  
                {{ $t('showMarkers') }}
              </label>
            </div>


            <div v-if="jsonVisible" style="display: flex; margin-top: 10px; margin-right: 20px;">
              <span :id="'jsonColorMoving' + track.gpsTrack.id" style="display:inline-block; width:20px; height:20px; border-radius:50%; cursor:pointer; margin-right:6px;" :style="{ 'background-color': getColorHex(jsonColorMoving) || track.gpsTrack.color }"></span>
              <b-popover :target="'jsonColorMoving' + track.gpsTrack.id" triggers="focus" placement="top" :delay="{ 'show': 0, 'hide': 0 }">
                <SketchPicker v-model="jsonColorMoving" :disableAlpha="true" :disableFields="true"></SketchPicker>
              </b-popover>

              <span :id="'jsonColorPaused' + track.gpsTrack.id" style="display:inline-block; width:20px; height:20px; border-radius:50%; cursor:pointer; margin-right:6px;" :style="{ 'background-color': getColorHex(jsonColorPaused) || track.gpsTrack.color }"></span>
              <b-popover :target="'jsonColorPaused' + track.gpsTrack.id" triggers="focus" placement="top" :delay="{ 'show': 0, 'hide': 0 }">
                <SketchPicker v-model="jsonColorPaused" :disableAlpha="true" :disableFields="true"></SketchPicker>
              </b-popover>

              <span :id="'jsonColorHover' + track.gpsTrack.id" style="display:inline-block; width:20px; height:20px; border-radius:50%; cursor:pointer; margin-right:6px;" :style="{ 'background-color': getColorHex(jsonColorHover) || track.gpsTrack.color }"></span>
              <b-popover :target="'jsonColorHover' + track.gpsTrack.id" triggers="focus" placement="top" :delay="{ 'show': 0, 'hide': 0 }">
                <SketchPicker v-model="jsonColorHover" :disableAlpha="true" :disableFields="true"></SketchPicker>
              </b-popover>

              <span :id="'jsonMarkerColor' + track.gpsTrack.id" style="display:inline-block; width:20px; height:20px; border-radius:50%; cursor:pointer; margin-right:6px;" :style="{ 'background-color': getColorHex(jsonMarkerColor) || track.gpsTrack.color }"></span>
              <b-popover :target="'jsonMarkerColor' + track.gpsTrack.id" triggers="focus" placement="top" :delay="{ 'show': 0, 'hide': 0 }">
                <SketchPicker v-model="jsonMarkerColor" :disableAlpha="true" :disableFields="true"></SketchPicker>
              </b-popover>

              <label style="margin-left:6px; margin-right:3px;">
                <b-form-checkbox style="margin-right: 2px; margin-top: 3px" class="display-inline" v-model="jsonShowMarkers">
                </b-form-checkbox> 
                {{ $t('showMarkers') }}
              </label>
            </div>
          
          </dev>
        </div>  
      </div>  
      <div ref="weatherModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Pogoda <span v-if="weatherDate">({{ weatherDate }})</span><span v-if="weatherCoords">: {{ weatherCoords.lat.toFixed(5) }}, {{ weatherCoords.lon.toFixed(5) }}</span></h4>
              <button type="button" class="btn-close" aria-label="Close" @click="closeWeatherModal"></button>
            </div>
            <div class="modal-body">
              <div v-if="weatherLoading" class="text-center" style="min-height: 200px; display:flex; align-items:center; justify-content:center;">
                <img :src="icons.spinnerBlack" style="height: 32px; animation: rotation 2s infinite linear;" />
              </div>
              <div v-else>
                <div v-if="weatherError" class="alert alert-danger">{{ weatherError }}</div>
                <div v-else>
                  <div :id="'chart_weather_' + track.gpsTrack.id" style="min-height: 320px;"></div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="closeWeatherModal">{{ $t('close') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import BaseComponent from '@/components/Base.vue';
import {dragElement, formatDateDay, formatTimeSeconds} from '@/ts/utils';
import Track from '@/ts/Track';
import axios from 'axios';
import Highcharts from 'highcharts';
import { AlertStatus } from '@/ts/types';
import { speedBetweenPoints, distanceBetweenPoints } from '@/ts/utils/coords';
import { EventBus } from '@/ts/EventBus';
// @ts-ignore
import GPX from 'gpx-parser-builder';
import * as xml2js from 'xml2js';
import { defineComponent, type PropType } from "vue";
import { log as debugLog } from '@/ts/debug';

export default defineComponent({
    extends: BaseComponent,
    data(): any {
        const canvasSpeedLayer: any = null;
        const speedPoints: {lat: number, lon: number, speed: number}[] = [];
        const canvasTimeLayer: any = null;
        const timePoints: {lat: number, lon: number, time: string}[] = [];
        const speedTrack: any = null;
        const trackDetailsLoading: boolean = false;
        const maximizedDetails: boolean = true;

        return {
          maximizedDetails,
          additionalTracksOnMap: 0,
          trackDetailsLoading,
          speedTrackVisible: false,
          speedTrack,
          timeLabelsVisible: false,
          timePoints,
          canvasTimeLayer,
          speedLabelsVisible: false,
          speedPoints,
          canvasSpeedLayer,
          debug: false,
          weatherLoading: false,
          weatherError: '' as string,
          weatherChart: null as any,
          weatherHours: [] as string[],
          weatherTemp: [] as number[],
          weatherAppTemp: [] as number[],
          weatherDate: '' as string,
          weatherCoords: null as any,
          // GPX segments UI state (reactive small UI state only)
          gpxVisible: false,
          gpxColor1: '',
          gpxColor2: '',
          gpxColor3: '',
          gpxShowMarkers: false,
          // JSON segments UI state
          jsonVisible: false,
          jsonPushVisible: false,
          jsonPushTrack: null as any,
          jsonColorMoving: '',
          jsonColorPaused: '',
          jsonColorHover: '',
          jsonMarkerColor: '',
          jsonShowMarkers: false
        };
    },
    created() {
        // non-reactive containers for performance; keep them off the Vue reactivity system
        //@ts-ignore
        this._gpxPolylines = [];
        //@ts-ignore
        this._gpxMarkers = [];
        //@ts-ignore
        this._gpxPoints = [];
        //@ts-ignore
        this._gpxHoveredIndex = null;
        // initialize color pickers from track color
        this.gpxColor1 = '#051dfa';
        this.gpxColor2 = '#00c91b';
        this.gpxColor3 = '#e6e205';
        // initialize JSON non-reactive containers and colors
        //@ts-ignore
        this._jsonPolylines = [];
        //@ts-ignore
        this._jsonMarkers = [];
        //@ts-ignore
        this._jsonPoints = [];
        //@ts-ignore
        this._jsonHoveredIndex = null;
        //@ts-ignore
        this._jsonPushTrack = null;
        this.jsonColorMoving = '#051dfa';
        this.jsonColorPaused = '#9e0000';
        this.jsonColorHover = '#00c91b';
        this.jsonMarkerColor = '#e6e205';
      },
    mounted() {
        dragElement(this.$refs.detailsWindow, this.$refs.detailsWindowHeader);
        this.$refs.detailsWindowHeader.addEventListener('click', this.newZIndexForDetails);
        this.onMaximizeChanged();
    },
    beforeDestroy() {
        if (this.timeLabelsVisible) {
          this.showHideTimeLables();
        }
        if (this.speedLabelsVisible) {
          this.showHideSpeedLables();
        }
        if (this.speedTrackVisible) {
          this.colorTrackBySpeed();
        }
        if (this.gpxVisible) {
          try { this.hideGPXSegments(); } catch (e) {}
        }
        if (this.jsonVisible) {
          try { this.hideJSONSegments(); } catch (e) {}
        }
        if (this.jsonPushVisible) {
          try { this.hideJSONPushTrack(); } catch (e) {}
        }
    },
    methods: {
        centerTrack() {
            const trackBounds = new L.LatLngBounds(window.tracks[this.track.id].mapTracks[0].getBounds().getNorthEast(), window.tracks[this.track.id].mapTracks[0].getBounds().getSouthWest());
            for (const mapTrack of window.tracks[this.track.id].mapTracks) {
              trackBounds.extend(mapTrack.getBounds());
            }
            window.mainmap.fitBounds(trackBounds);
        },
        fixParse(gpxString: string) {
            let gpx: {'trk': {'trkseg': {'trkpt': {'time': string, '$': {lat: number, lon: number}}[]}[]}[]};
            xml2js.parseString(
              gpxString,
              {
                explicitArray: false,
              },
              (err, xml) => {
                if (err) {
                  return;
                }
                if (!xml.gpx) {
                  return;
                }

                gpx = new GPX({
                  attributes: xml.gpx.$,
                  metadata: xml.gpx.metadata,
                  wpt: xml.gpx.wpt,
                  rte: xml.gpx.rte,
                  trk: xml.gpx.trk,
                });
              }
            );

            return gpx;
        },
        showUploadModal() {
            EventBus.$emit('openSaveTrackModal' + this.track.gpsTrack.id);
            this.track.maximized = false;
        },
        closeWeatherModal() {
            if (this.weatherChart) {
              try { this.weatherChart.destroy(); } catch (e) {}
              this.weatherChart = null;
            }
            this.weatherLoading = false;
            const modal = this.$refs.weatherModal as HTMLElement;
            if (modal) {
              this.closeModal(modal);
            }
        },
        getTrackStartCoordinates() {
            try {
              const raw = this.track.gpsTrack.points_json_optimized;
              const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
              if (!Array.isArray(parsed) || parsed.length === 0) {
                return null;
              }
              const firstSegment = parsed[0];
              if (!Array.isArray(firstSegment) || firstSegment.length === 0) {
                return null;
              }
              const firstPoint = firstSegment[0];
              if (Array.isArray(firstPoint) && firstPoint.length >= 2) {
                return { lat: Number(firstPoint[0]), lon: Number(firstPoint[1]) };
              }
              if (firstPoint && typeof firstPoint === 'object' && firstPoint.latitude !== undefined && firstPoint.longitude !== undefined) {
                return { lat: Number(firstPoint.latitude), lon: Number(firstPoint.longitude) };
              }
              return null;
            } catch (e) {
              return null;
            }
        },
        async showWeatherModal() {
            this.weatherError = '';
            this.weatherHours = [];
            this.weatherTemp = [];
            this.weatherAppTemp = [];
            this.weatherDate = '';
            this.weatherLoading = true;
            this.weatherChart = null;
            // store coords for header display
            this.weatherCoords = this.getTrackStartCoordinates();
            const modal = this.$refs.weatherModal as HTMLElement;
            if (modal) {
              this.openModal(modal);
            }
            await this.fetchTrackWeather();
        },
        async fetchTrackWeather() {
            const coords = this.getTrackStartCoordinates();
            if (!coords) {
              this.weatherError = 'Nie można odczytać punktu startowego trasy.';
              this.weatherLoading = false;
              return;
            }
            const startTime: any = this.track.gpsTrack.start_time;
            let dateString = '';
            if (startTime) {
              if (typeof startTime === 'string') {
                dateString = startTime.slice(0, 10);
              } else if (startTime instanceof Date) {
                dateString = startTime.toISOString().slice(0, 10);
              } else {
                dateString = new Date(startTime).toISOString().slice(0, 10);
              }
            }
            if (!dateString) {
              this.weatherError = 'Nie można odczytać daty trasy.';
              this.weatherLoading = false;
              return;
            }
            this.weatherDate = dateString;
            try {
              const params = {
                latitude: coords.lat,
                longitude: coords.lon,
                start_date: dateString,
                end_date: dateString,
                hourly: ['temperature_2m', 'apparent_temperature'],
                timezone: 'Europe/Warsaw',
              };
              const response = await axios.get('https://archive-api.open-meteo.com/v1/archive', {
                params,
                paramsSerializer: (paramsObj: any) => {
                  const searchParams = new URLSearchParams();
                  for (const [key, value] of Object.entries(paramsObj)) {
                    if (Array.isArray(value)) {
                      value.forEach((v) => searchParams.append(key, String(v)));
                    } else {
                      searchParams.append(key, String(value));
                    }
                  }
                  return searchParams.toString();
                },
              });
              const hourly = response.data?.hourly;
              if (!hourly || !Array.isArray(hourly.time) || !Array.isArray(hourly.temperature_2m) || !Array.isArray(hourly.apparent_temperature)) {
                throw new Error('Odpowiedź API nie zawiera oczekiwanych danych pogodowych.');
              }
              this.weatherHours = hourly.time.map((time: string) => {
                const date = new Date(time);
                return date.toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Europe/Warsaw' });
              });
              this.weatherTemp = hourly.temperature_2m.map((value: any) => Number(value));
              this.weatherAppTemp = hourly.apparent_temperature.map((value: any) => Number(value));
              this.weatherError = '';
            } catch (fetchError: any) {
              this.weatherError = fetchError?.message || 'Błąd pobierania danych pogodowych.';
            } finally {
              this.weatherLoading = false;
              this.$nextTick(() => {
                if (this.weatherError || this.weatherLoading) {
                  return;
                }
                const chartId = 'chart_weather_' + this.track.gpsTrack.id;
                const chartEl = document.getElementById(chartId);
                if (!chartEl) {
                  this.weatherError = 'Nie można wykonać wykresu: element nie został znaleziony.';
                  return;
                }
                if (this.weatherChart) {
                  try { this.weatherChart.destroy(); } catch (e) {}
                }
                const startTimeObj = this.track.gpsTrack.start_time ? new Date(this.track.gpsTrack.start_time) : null;
                const endTimeObj = this.track.gpsTrack.end_time ? new Date(this.track.gpsTrack.end_time) : null;
                let plotBands = [] as any[];
                if (startTimeObj && !isNaN(startTimeObj.getTime()) && endTimeObj && !isNaN(endTimeObj.getTime())) {
                  const startHour = startTimeObj.getHours();
                  const endHour = endTimeObj.getHours() + ((endTimeObj.getMinutes() || endTimeObj.getSeconds() || endTimeObj.getMilliseconds()) ? 1 : 0);
                  plotBands = [{
                    from: startHour,
                    to: Math.min(endHour, this.weatherHours.length),
                    color: 'rgba(255, 0, 0, 0.15)',
                  }];
                }
                this.weatherChart = Highcharts.chart(chartEl, {
                  chart: {
                    type: 'line',
                  },
                  plotOptions: {
                    series: {
                      animation: false,
                    }
                  },
                  title: { text: 'Temperatura trasy' },
                  xAxis: {
                    categories: this.weatherHours,
                    title: { text: 'Godzina' },
                    plotBands,
                  },
                  yAxis: {
                    title: { text: 'Temperatura (°C)' },
                  },
                  tooltip: {
                    shared: true,
                    valueSuffix: ' °C',
                  },
                  series: [
                    { name: 'Temp.', data: this.weatherTemp, color: '#007bff' },
                  ],
                  credits: { enabled: false },
                });
              });
            }
        },
        dayIndex(date: Date) {
            if (date) {
              return 'day' + date.getDay()
            } else {
              return '';
            }
        },
        onDrawLayer(info: any) {
            let ctx = info.canvas.getContext('2d');
            ctx.clearRect(0, 0, info.canvas.width, info.canvas.height);
            ctx.font = "12px Arial";
            ctx.textAlign = 'center';
            for (let i = 0; i < this.timePoints.length; i++) {
              let timePoint = this.timePoints[i];
              if (info.bounds.contains([timePoint.lat, timePoint.lon])) {
                const dot = info.layer._map.latLngToContainerPoint([timePoint.lat, timePoint.lon]);
                const text = ctx.measureText(timePoint.time);
                ctx.fillStyle = 'white';
                ctx.fillRect(dot.x - text.width / 2 - 1, dot.y - 11, text.width + 2, 14);
                ctx.fillStyle = 'black';
                ctx.fillText(timePoint.time, dot.x, dot.y);
                ctx.strokeStyle = 'black';
                ctx.strokeRect(dot.x - text.width / 2 - 1, dot.y - 11, text.width + 2, 14);
              }
            }
            for (let i = 0; i < this.speedPoints.length; i++) {
              let speedPoint = this.speedPoints[i];
              if (info.bounds.contains([speedPoint.lat, speedPoint.lon])) {
                const dot = info.layer._map.latLngToContainerPoint([speedPoint.lat, speedPoint.lon]);
                const text = ctx.measureText(speedPoint.speed.toFixed(1));
                ctx.fillStyle = 'white';
                ctx.fillRect(dot.x - text.width / 2 - 1, dot.y - 11, text.width + 2, 14);
                ctx.fillStyle = 'black';
                ctx.fillText(speedPoint.speed.toFixed(1), dot.x, dot.y);
                ctx.strokeStyle = 'black';
                ctx.strokeRect(dot.x - text.width / 2 - 2, dot.y - 11, text.width + 4, 14);
              }
            }
        },
        showHideTimeLables() {
            if (this.timeLabelsVisible) {
              this.timePoints = [];
              this.canvasTimeLayer.removeFrom(window.mainmap);
              this.canvasTimeLayer = null;
            } else {
              this.timePoints = [];
              let index = 0;
              const gpx = this.fixParse(this.track.gpsTrack.gpx_file);
              if (gpx) {
                for (const fileTrack of gpx.trk) {
                  for (const segment of fileTrack.trkseg) {
                    for (const point of segment.trkpt) {
                      if (index % 10 == 0) {
                        this.timePoints.push({lat: Number(point.$.lat), lon: Number(point.$.lon), time: formatTimeSeconds(new Date(point.time))});
                      }
                      index = index + 1;
                    }
                  }
                }
                // @ts-ignore
                this.canvasTimeLayer = L.canvasLayer();
                this.canvasTimeLayer.delegate(this).addTo(window.mainmap);
                this.canvasTimeLayer._onLayerDidMove();
                this.canvasTimeLayer.needRedraw();
              } else {
                this.createAlert(AlertStatus.danger, this.$t('gpxParsingError').toString(), 2000);
              }
            }
            this.timeLabelsVisible = !this.timeLabelsVisible;
        },
        showHideSpeedLables() {
            if (this.speedLabelsVisible) {
              this.speedPoints = [];
              this.canvasSpeedLayer.removeFrom(window.mainmap);
              this.canvasSpeedLayer = null;
            } else {
              this.speedPoints = [];
              let index = 0;
              const gpx = this.fixParse(this.track.gpsTrack.gpx_file);
              if (gpx) {
                let last_point = null;
                for (const fileTrack of gpx.trk) {
                  for (const segment of fileTrack.trkseg) {
                    for (const point of segment.trkpt) {
                      if (! last_point) {
                        last_point = point;
                      } else if (index % 10 == 0) {
                        const speed = speedBetweenPoints(point, last_point);
                        last_point = point;
                        this.speedPoints.push({lat: Number(point.$.lat), lon: Number(point.$.lon), speed: speed});
                      }
                      index = index + 1;
                    }
                  }
                }
                // @ts-ignore
                this.canvasSpeedLayer = L.canvasLayer();
                this.canvasSpeedLayer.delegate(this).addTo(window.mainmap);
                this.canvasSpeedLayer._onLayerDidMove();
                this.canvasSpeedLayer.needRedraw();
              } else {
                this.createAlert(AlertStatus.danger, this.$t('gpxParsingError').toString(), 2000);
              }
            }
            this.speedLabelsVisible = !this.speedLabelsVisible;
        },
        colorTrackBySpeed() {
            if (! this.speedTrack) {
              const points: {lat: number, lon: number, speed?: number}[] = [];
              const SAMPLE = 10;
              const gpx = this.fixParse(this.track.gpsTrack.gpx_file);
              if (gpx) {
                for (const fileTrack of gpx.trk) {
                  for (const segment of fileTrack.trkseg) {
                    if (!segment || !segment.trkpt || segment.trkpt.length === 0) {
                      continue;
                    }
                    const segPts = segment.trkpt;
                    // add starting point of the segment so first chunk is drawn
                    points.push({lat: Number(segPts[0].$.lat), lon: Number(segPts[0].$.lon)});
                    let lastSampleIdx = 0;
                    for (let i = SAMPLE; i < segPts.length; i += SAMPLE) {
                      const speed = speedBetweenPoints(segPts[i], segPts[lastSampleIdx]);
                      points.push({lat: Number(segPts[i].$.lat), lon: Number(segPts[i].$.lon), speed: speed});
                      lastSampleIdx = i;
                    }
                    // handle remainder of the segment
                    if (lastSampleIdx < segPts.length - 1) {
                      const lastIdx = segPts.length - 1;
                      const speed = speedBetweenPoints(segPts[lastIdx], segPts[lastSampleIdx]);
                      points.push({lat: Number(segPts[lastIdx].$.lat), lon: Number(segPts[lastIdx].$.lon), speed: speed});
                    }
                  }
                }
                this.speedTrack = L.multiOptionsPolyline(points as unknown as L.LatLng[], {
                  multiOptions: {
                    optionIdxFn: (latLng: any, prevLatLng: any, index: number, allLatlngs: any[]) => {
                      const altThresholds = this.$store.state.speedThresholds;
                      // Prefer the next point's speed so the drawn segment corresponds to its measured speed
                      let speedValue = latLng.speed;
                      if (allLatlngs && (index + 1) < allLatlngs.length && allLatlngs[index + 1] && allLatlngs[index + 1].speed !== undefined) {
                        speedValue = allLatlngs[index + 1].speed;
                      }
                      for (let i = 1; i < altThresholds.length; ++i) {
                          if (speedValue <= altThresholds[i]) {
                              return i - 1;
                          }
                      }
                      return altThresholds.length - 1;
                    },
                    options: this.$store.state.speedColors,
                  },
                  //@ts-ignore
                  weight: 5,
                  lineCap: 'butt',
                  opacity: 0.75,
                 smoothFactor: 1
                })
              } else {
                this.createAlert(AlertStatus.danger, this.$t('gpxParsingError').toString(), 2000);
              }
            }
            if (this.speedTrackVisible) {
              this.speedTrack.removeFrom(window.mainmap);
              this.$store.commit('setSpeedLegendVisible', false);
              this.additionalTracksOnMap -= 1;
              if (this.additionalTracksOnMap == 0) {
                this.track.checked = true;
              }
            } else {
              this.speedTrack.addTo(window.mainmap);
              this.$store.commit('setSpeedLegendVisible', true);
              this.additionalTracksOnMap += 1;
              this.track.checked = false;
            }
            this.speedTrackVisible = !this.speedTrackVisible;
        },
        toggleGPX() {
          if (! this.gpxVisible) {
            // show: parse once then add polylines or re-add existing
            if (! (this as any)._gpxPolylines || (this as any)._gpxPolylines.length === 0) {
              this.parseGPXSegments();
            } else {
              for (const pl of (this as any)._gpxPolylines) {
                pl.addTo(window.mainmap);
              }
            }
            this.gpxVisible = true;
            // when showing GPX segments, hide main track
            this.track.checked = false;
            this.additionalTracksOnMap += 1;
            // If markers toggle is on, re-add markers for all segments
            if (this.gpxShowMarkers) {
              // @ts-ignore
              const pointsArr = (this as any)._gpxPoints || [];
              for (let idx = 0; idx < pointsArr.length; idx++) {
                try { this.showMarkersForSegment(idx); } catch (e) {}
              }
            }
          } else {
            this.hideGPXSegments();
            this.additionalTracksOnMap -= 1;
            if (this.additionalTracksOnMap == 0) {
              this.track.checked = true;
            }
          }
        },
        parseGPXSegments() {
            const gpx = this.fixParse(this.track.gpsTrack.gpx_file);
            if (! gpx) {
                this.createAlert(AlertStatus.danger, this.$t('gpxParsingError').toString(), 2000);
                return;
            }
            //@ts-ignore
            this._gpxPolylines = [];
            //@ts-ignore
            this._gpxPoints = [];
            //@ts-ignore
            this._gpxMarkers = [];
            //@ts-ignore
            this._gpxHoveredIndex = null;
            let segIndex = 0;
            for (const fileTrack of gpx.trk) {
              for (const segment of fileTrack.trkseg) {
                if (!segment || !segment.trkpt || segment.trkpt.length === 0) {
                  continue;
                }
                const latlngs: any[] = [];
                const pts: any[] = [];
                for (const point of segment.trkpt) {
                  latlngs.push([Number(point.$.lat), Number(point.$.lon)]);
                  // store raw point for lazy tooltip parsing; keep lightweight wrapper in non-reactive array
                  pts.push({lat: Number(point.$.lat), lon: Number(point.$.lon), raw: point});
                }
                const poly: any = L.polyline(latlngs, { color: this.getColorHex(this.gpxColor1) || this.track.gpsTrack.color, weight: 10, opacity: 0.9 });
                // store non-reactive
                //@ts-ignore
                this._gpxPolylines.push(poly);
                //@ts-ignore
                this._gpxPoints.push(pts);
                //@ts-ignore
                this._gpxMarkers.push([]);
                ((idx) => {
                  poly.on('mouseover', (e: any) => {
                    poly.setStyle({ color: this.getColorHex(this.gpxColor2) || this.track.gpsTrack.color, weight: 10 });
                    //@ts-ignore
                    this._gpxHoveredIndex = idx;
                    // marker visibility is controlled by the `gpxShowMarkers` watcher
                  });
                  poly.on('mouseout', (e: any) => {
                    poly.setStyle({ color: this.getColorHex(this.gpxColor1) || this.track.gpsTrack.color, weight: 10 });
                    //@ts-ignore
                    this._gpxHoveredIndex = null;
                    // only hide markers on mouseout if the global showMarkers toggle is off
                    if (! this.gpxShowMarkers) {
                      this.hideMarkersForSegment(idx);
                    }
                  });
                })(segIndex);
                poly.addTo(window.mainmap);
                segIndex++;
              }
            }
        },
        showMarkersForSegment(idx: number) {
            //@ts-ignore
            const pts = this._gpxPoints && this._gpxPoints[idx];
            if (! pts) { return; }
            //@ts-ignore
            const existing = this._gpxMarkers && this._gpxMarkers[idx];
            if (existing && existing.length > 0) {
              // reuse existing markers: add them back to the map if needed
              for (const m of existing) {
                try { if (!m._map) { 
                  m.addTo(window.mainmap);
                } } catch (e) {}
              }
              return;
            }
            const markers: any[] = [];
            const baseColor = this.getColorHex(this.gpxColor3) || this.track.gpsTrack.color;
            for (let i = 0; i < pts.length; i++) {
              const p = pts[i];
              const m = L.circleMarker([p.lat, p.lon], { radius: 5, color: baseColor, fillColor: baseColor, fillOpacity: 1 });
              // attach segment index to marker so hover can affect parent polyline
              // @ts-ignore
              m._gpxSegmentIdx = idx;
              // generate tooltip content immediately (no lazy binding)
              try {
                const raw = p.raw;
                const metrics = this.extractMetricsFromRaw(raw);
                const timeStr = this.formatLocalTime(raw && raw.time);
                const hr = metrics.hr !== null && metrics.hr !== undefined ? metrics.hr : '-';
                const cad = metrics.cad !== null && metrics.cad !== undefined ? metrics.cad : '-';
                const power = metrics.power !== null && metrics.power !== undefined ? metrics.power : '-';
                let speedText = '-';
                if (metrics.speed !== null && metrics.speed !== undefined && !isNaN(metrics.speed)) {
                  speedText = (Number(metrics.speed) * 3.6).toFixed(1) + ' km/h';
                } else {
                  if (i > 0) {
                    const prev = pts[i - 1];
                    if (prev && prev.raw && prev.raw.time && raw && raw.time) {
                      const t1 = new Date(prev.raw.time).getTime();
                      const t2 = new Date(raw.time).getTime();
                      const dt = (t2 - t1) / 1000.0;
                      if (dt > 0) {
                        const dist = distanceBetweenPoints(prev.lat, prev.lon, p.lat, p.lon); // meters
                        const speedMps = dist / dt;
                        speedText = (speedMps * 3.6).toFixed(1) + ' km/h';
                      }
                    }
                  }
                }

                const content = `<div style="font-size:12px; line-height:1.2">` +
                  `<div>Czas: <b>${timeStr}</b></div>` +
                  `<div>Tętno: <b>${hr}</b></div>` +
                  `<div>Kad: <b>${cad}</b></div>` +
                  `<div>Moc: <b>${power}</b></div>` +
                  `<div>Prędkość: <b>${speedText}</b></div>` +
                  `</div>`;

                m.bindTooltip(content, { direction: 'top', offset: [0, -8], opacity: 0.95 });
                // @ts-ignore
                m._gpxTooltipBound = true;
              } catch (e) {
                debugLog(e);
              }
              // when hovering a marker, ensure its parent polyline uses color2
              m.on('mouseover', (e: any) => {
                try {
                  m.openTooltip();
                } catch (e) {}
                try {
                  // @ts-ignore
                  const segIdx = m._gpxSegmentIdx;
                  if (segIdx !== null && segIdx !== undefined && this._gpxPolylines && this._gpxPolylines[segIdx]) {
                    this._gpxPolylines[segIdx].setStyle({ color: this.getColorHex(this.gpxColor2) || this.track.gpsTrack.color, weight: 10 });
                    // @ts-ignore
                    this._gpxHoveredIndex = segIdx;
                  }
                } catch (e) {}
              });
              m.on('mouseout', (e: any) => {
                try { m.closeTooltip(); } catch (e) {}
                try {
                  // restore parent polyline color if marker was controlling hover
                  // @ts-ignore
                  const segIdx = m._gpxSegmentIdx;
                  if (segIdx !== null && segIdx !== undefined && this._gpxPolylines && this._gpxPolylines[segIdx]) {
                    // only reset if polyline isn't hovered by mouse (poly will set color on its own mouseover)
                    if (this._gpxHoveredIndex === segIdx) {
                      this._gpxPolylines[segIdx].setStyle({ color: this.getColorHex(this.gpxColor1) || this.track.gpsTrack.color, weight: 10 });
                      // @ts-ignore
                      this._gpxHoveredIndex = null;
                    }
                  }
                } catch (e) {}
              });
              m.addTo(window.mainmap);
              markers.push(m);
            }
            //@ts-ignore
            this._gpxMarkers[idx] = markers;
        },

        extractMetricsFromRaw(raw: any) {
            const unwrap = (v: any) => {
                if (v === undefined || v === null) return null;
                if (typeof v === 'object') {
                    if (v._ !== undefined) return v._;
                    if (v['#text'] !== undefined) return v['#text'];
                    return null;
                }
                return v;
            };
            let hr: any = null;
            let cad: any = null;
            let power: any = null;
            let speed: any = null;
            const ext = raw && (raw.extensions || raw.extension);
            if (ext) {
                // find TrackPointExtension object (namespace may vary)
                let tpe = null;
                for (const k in ext) {
                    if (k && k.toLowerCase().indexOf('trackpointextension') >= 0) {
                        tpe = ext[k];
                        break;
                    }
                }
                if (tpe) {
                    hr = unwrap(tpe['gpxtpx:hr'] || tpe.hr || tpe['hr']);
                    cad = unwrap(tpe['gpxtpx:cad'] || tpe.cad || tpe['cad']);
                    speed = unwrap(tpe['gpxtpx:speed'] || tpe.speed || tpe['speed']);
                } else {
                    hr = unwrap(ext['gpxtpx:hr'] || ext.hr || ext['hr']);
                    cad = unwrap(ext['gpxtpx:cad'] || ext.cad || ext['cad']);
                    speed = unwrap(ext['gpxtpx:speed'] || ext.speed || ext['speed']);
                }
                power = unwrap(ext['power'] || ext.power);
            }
            return { hr: hr !== null ? Number(hr) : null, cad: cad !== null ? Number(cad) : null, power: power !== null ? Number(power) : null, speed: speed !== null ? Number(speed) : null };
        },

        formatLocalTime(timeVal: any) {
            if (!timeVal) { return '-'; }
            const d = (timeVal instanceof Date) ? timeVal : new Date(timeVal);
            if (isNaN(d.getTime())) { return '-'; }
            const pad = (n: number, len = 2) => n.toString().padStart(len, '0');
            const hh = pad(d.getHours());
            const mm = pad(d.getMinutes());
            const ss = pad(d.getSeconds());
            const ms = d.getMilliseconds().toString().padStart(3, '0');
            return `${hh}:${mm}:${ss}.${ms}`;
        },
        hideMarkersForSegment(idx: number) {
            //@ts-ignore
            const markers = this._gpxMarkers && this._gpxMarkers[idx];
            if (! markers) { return; }
            for (const m of markers) {
              try { m.removeFrom(window.mainmap); } catch (e) {}
            }
            // keep marker references for reuse (do not clear the array)
        },
        hideGPXSegments() {
            //@ts-ignore
            if (this._gpxPolylines) {
              for (const pl of this._gpxPolylines) {
                try { pl.removeFrom(window.mainmap); } catch (e) {}
              }
            }
            //@ts-ignore
            if (this._gpxMarkers) {
              for (const list of this._gpxMarkers) {
                for (const m of list) {
                  try { m.removeFrom(window.mainmap); } catch (e) {}
                }
              }
            }
            //@ts-ignore
            this._gpxPolylines = [];
            //@ts-ignore
            this._gpxMarkers = [];
            //@ts-ignore
            this._gpxPoints = [];
            //@ts-ignore
            this._gpxHoveredIndex = null;
            this.gpxVisible = false;
        },
        getColorHex(val: any) {
            if (!val) { return null; }
            if (typeof val === 'string') { return val; }
            if (val.hex) { return val.hex; }
            if (val.rgba) {
              const r = val.rgba.r; const g = val.rgba.g; const b = val.rgba.b; const a = val.rgba.a;
              return `rgba(${r},${g},${b},${a})`;
            }
            return null;
        },
        saveGPX() {
            const date = formatDateDay(this.track.gpsTrack.start_time);
            let filename = this.track.gpsTrack.name + ' source.gpx';
            if (date) {
              filename = this.track.gpsTrack.name + ' ' + date + ' source.gpx';
            }
            this.saveFile(this.track.gpsTrack.gpx_file, filename)
        },
        saveJSON() {
            const date = formatDateDay(this.track.gpsTrack.start_time);
            let filename = this.track.gpsTrack.name + ' source.json';
            if (date) {
              filename = this.track.gpsTrack.name + ' ' + date + ' source.json';
            }
            this.saveFile(this.track.gpsTrack.json_file, filename)
        },
        newZIndexForDetails(event: MouseEvent) {
            this.$refs.detailsWindow.style.zIndex = String(1000000 + window.detailsLastZIndex);
            window.detailsLastZIndex = window.detailsLastZIndex + 1;
        },
        toggleMaximizedDetails() {
            this.maximizedDetails = !this.maximizedDetails;
        },
        maximizeTrack(e: Event) {
            if (this.track.gpsTrack.gpx_file === undefined) {
              this.trackDetailsLoading = true;
              axios.get(window.apiHost + 'api/tracks/' + this.track.gpsTrack.id + '/').then(
                (response) => {
                  this.track.gpsTrack.points_json = response.data.details.points_json;
                  this.track.gpsTrack.gpx_file = response.data.details.gpx_file;
                  this.track.gpsTrack.json_file = response.data.details.json_file;
                },
              ).catch(
                (response) => {
                  this.createAlert(AlertStatus.danger, this.$t('trackError').toString(), 2000);
                },
              ).finally(
                () => {
                  this.trackDetailsLoading = false;
                },
              );
            }

            //this.maximized = true;
            this.$refs.detailsWindow.style.left = (window.detailsX + document.getElementById('map').getBoundingClientRect().left) + 'px';
            this.$refs.detailsWindow.style.top = '' + window.detailsY + 'px';
            this.$refs.detailsWindow.style.zIndex = String(1000000 + window.detailsLastZIndex);
            window.detailsLastZIndex = window.detailsLastZIndex + 1;
            window.detailsX = window.detailsX + 50;
            window.detailsY = window.detailsY + 50;
            if (window.detailsX > 400) {
              window.detailsX = 50;
            }
            if (window.detailsY > 400) {
              window.detailsY = 50;
            }
            if (! this.maximizedDetails) {
              this.toggleMaximizedDetails();
            }
        },
        onSpeedScaleChooseChange() {
            if (this.speedTrackVisible) {
              this.colorTrackBySpeed();
              this.speedTrack = null;
              this.colorTrackBySpeed();
            } else {
              this.speedTrack = null;
            }
        },
        onMaximizeChanged() {
            if (this.track.maximized) {
              this.maximizeTrack(null);
            } else {
              if (this.timeLabelsVisible) {
                this.showHideTimeLables();
              }
              if (this.speedLabelsVisible) {
                this.showHideSpeedLables();
              }
              if (this.speedTrackVisible) {
                this.colorTrackBySpeed();
              }
              if (this.gpxVisible) {
                try { this.hideGPXSegments(); } catch (e) {}
              }
              if (this.jsonVisible) {
                try { this.hideJSONSegments(); } catch (e) {}
              }
              if (this.jsonPushVisible) {
                try { this.hideJSONPushTrack(); } catch (e) {}
              }
            }
        },
        toggleJSON() {
          if (! this.jsonVisible) {
            if (! (this as any)._jsonPolylines || (this as any)._jsonPolylines.length === 0) {
              this.parseJSONSegments();
            } else {
              for (const pl of (this as any)._jsonPolylines) {
                pl.addTo(window.mainmap);
              }
            }
            this.jsonVisible = true;
            this.additionalTracksOnMap += 1;
            this.track.checked = false;
            // If markers toggle is on, re-add markers for all json segments
            if (this.jsonShowMarkers) {
              // @ts-ignore
              const pointsArr = (this as any)._jsonPoints || [];
              for (let idx = 0; idx < pointsArr.length; idx++) {
                try { this.showMarkersForJsonSegment(idx); } catch (e) {}
              }
            }
          } else {
            this.hideJSONSegments();
            this.additionalTracksOnMap -= 1;
            if (this.additionalTracksOnMap == 0) {
              this.track.checked = true;
            }
          }
        },
        toggleJSONPush() {
          if (! this.jsonPushVisible) {
            if (! this.jsonPushTrack) {
              this.createJSONPushTrack();
            }
            if (this.jsonPushTrack) {
              this.jsonPushTrack.addTo(window.mainmap);
              this.additionalTracksOnMap += 1;
            }
            this.jsonPushVisible = true;
            this.track.checked = false;
          } else {
            this.hideJSONPushTrack();
            this.additionalTracksOnMap -= 1;
            if (this.additionalTracksOnMap == 0) {
              this.track.checked = true;
            }
          }
        },
        hideJSONPushTrack() {
          if (this.jsonPushTrack) {
            this.jsonPushTrack.removeFrom(window.mainmap);
          }
          this.jsonPushVisible = false;
        },
        createJSONPushTrack() {
            let data: any = null;
            try {
              data = (typeof this.track.gpsTrack.json_file === 'string') ? JSON.parse(this.track.gpsTrack.json_file) : this.track.gpsTrack.json_file;
            } catch (e) {
              data = this.track.gpsTrack.json_file;
            }
            if (! data || ! data.details) {
                this.createAlert(AlertStatus.danger, this.$t('jsonParsingError').toString(), 2000);
                return;
            }
            const details: any[] = data.details;
            const allPoints: any[] = [];
            for (let i = 0; i < details.length; i++) {
              const point = details[i];
              const lat = Number(point.lat);
              const lon = Number(point.lon);
              const pwr = (point.pwr !== undefined && point.pwr !== null) ? Number(point.pwr) : 0;
              const cad = (point.cad !== undefined && point.cad !== null) ? Number(point.cad) : 0;
              const gpsSpd = (point.gpsSpd !== undefined && point.gpsSpd !== null) ? Number(point.gpsSpd) : null;
              const timestamp = point.timestamp ? new Date(point.timestamp).getTime() : null;
              allPoints.push({ lat, lon, raw: point, pwr, cad, gpsSpd, timestamp, speed: null, styleIdx: 3 });
            }
            // compute speeds (m/s -> km/h)
            for (let i = 1; i < allPoints.length; i++) {
              const cur = allPoints[i];
              if (cur.gpsSpd !== null && !isNaN(cur.gpsSpd)) {
                cur.speed = Number(cur.gpsSpd) * 3.6;
              } else {
                const prev = allPoints[i - 1];
                if (prev && prev.timestamp && cur.timestamp && cur.timestamp > prev.timestamp) {
                  const dt = (cur.timestamp - prev.timestamp) / 1000.0;
                  if (dt > 0) {
                    const dist = distanceBetweenPoints(prev.lat, prev.lon, cur.lat, cur.lon);
                    cur.speed = (dist / dt) * 3.6;
                  }
                }
              }
              if (cur.speed === null || isNaN(cur.speed)) {
                cur.speed = 0;
              }
            }
            if (allPoints.length > 0 && (allPoints[0].speed === null || isNaN(allPoints[0].speed))) {
              allPoints[0].speed = 0;
            }

            // New logic: iterate all points (no segmentation). Start pushing only when previous point had paused==1
            // and current point has no power/cadence. Continue pushing until a point with power or cadence appears.
            for (let i = 0, pushActive = false; i < allPoints.length; i++) {
              const p = allPoints[i];
              if (pushActive) {
                if (p.pwr !== 0 || p.cad !== 0) {
                  pushActive = false; // stop pushing, classify this point normally below
                } else {
                  p.styleIdx = 0; // black = push
                  continue;
                }
              }

              // If previous point was paused==1 we may start pushing here (only if current has no power/cadence)
              if (i > 0) {
                const prevPaused = (allPoints[i - 1].raw && allPoints[i - 1].raw.paused !== undefined && allPoints[i - 1].raw.paused !== null) ? Number(allPoints[i - 1].raw.paused) : 0;
                if (prevPaused === 1 && p.pwr === 0 && p.cad === 0) {
                  pushActive = true;
                  p.styleIdx = 0;
                  continue;
                }
              }

              // classify by speed when not pushing
              const speed = p.speed || 0;
              if (speed < 6) {
                p.styleIdx = 1; // red: ślimacza jazda
              } else if (speed <= 8) {
                p.styleIdx = 2; // yellow: wolna jazda
              } else {
                p.styleIdx = 3; // green: jazda
              }
            }

            const pointsForPolyline: any[] = [];
            for (const p of allPoints) {
              pointsForPolyline.push({ lat: p.lat, lon: p.lon, styleIdx: p.styleIdx });
            }

            this.jsonPushTrack = L.multiOptionsPolyline(pointsForPolyline as unknown as L.LatLng[], {
              multiOptions: {
                optionIdxFn: (latLng: any, prevLatLng: any, index: number, allLatlngs: any[]) => {
                  const next = allLatlngs && (index + 1) < allLatlngs.length ? allLatlngs[index + 1] : latLng;
                  return (next && next.styleIdx !== undefined) ? next.styleIdx : (latLng && latLng.styleIdx !== undefined ? latLng.styleIdx : 3);
                },
                options: [
                  { color: '#000000', weight: 6, opacity: 0.95 },
                  { color: '#ff0000', weight: 6, opacity: 0.95 },
                  { color: '#ffd700', weight: 6, opacity: 0.95 },
                  { color: '#00aa00', weight: 6, opacity: 0.95 }
                ]
              },
              //@ts-ignore
              weight: 5,
              lineCap: 'butt',
              opacity: 0.9,
              smoothFactor: 1
            });
        },
        parseJSONSegments() {
            let data: any = null;
            try {
              data = (typeof this.track.gpsTrack.json_file === 'string') ? JSON.parse(this.track.gpsTrack.json_file) : this.track.gpsTrack.json_file;
            } catch (e) {
              data = this.track.gpsTrack.json_file;
            }
            if (! data || ! data.details) {
                this.createAlert(AlertStatus.danger, this.$t('gpxParsingError').toString(), 2000);
                return;
            }
            //@ts-ignore
            this._jsonPolylines = [];
            //@ts-ignore
            this._jsonPoints = [];
            //@ts-ignore
            this._jsonMarkers = [];
            //@ts-ignore
            this._jsonHoveredIndex = null;
            let segIndex = 0;
            let currentSegPts: any[] = [];
            let currentPaused: any = null;
            const details = data.details;
            for (let i = 0; i < details.length; i++) {
              const point = details[i];
              const paused = (point.paused !== undefined && point.paused !== null) ? Number(point.paused) : 0;
              if (currentSegPts.length === 0) {
                currentPaused = paused;
                currentSegPts.push({ lat: Number(point.lat), lon: Number(point.lon), raw: point });
              } else if (paused === currentPaused) {
                currentSegPts.push({ lat: Number(point.lat), lon: Number(point.lon), raw: point });
              } else {
                // finalize segment
                const latlngs: any[] = [];
                const pts: any[] = [];
                for (const p of currentSegPts) { latlngs.push([p.lat, p.lon]); pts.push(p); }
                const color = (currentPaused === 0) ? this.getColorHex(this.jsonColorMoving) || this.track.gpsTrack.color : this.getColorHex(this.jsonColorPaused) || this.track.gpsTrack.color;
                const poly: any = L.polyline(latlngs, { color: color, weight: 10, opacity: 0.9 });
                //@ts-ignore
                this._jsonPolylines.push(poly);
                //@ts-ignore
                this._jsonPoints.push(pts);
                //@ts-ignore
                this._jsonMarkers.push([]);
                const segPaused = currentPaused;
                ((idx, segPausedLocal) => {
                  poly.on('mouseover', (e: any) => {
                    poly.setStyle({ color: this.getColorHex(this.jsonColorHover) || this.track.gpsTrack.color, weight: 10 });
                    //@ts-ignore
                    this._jsonHoveredIndex = idx;
                  });
                  poly.on('mouseout', (e: any) => {
                    poly.setStyle({ color: (segPausedLocal === 0) ? (this.getColorHex(this.jsonColorMoving) || this.track.gpsTrack.color) : (this.getColorHex(this.jsonColorPaused) || this.track.gpsTrack.color), weight: 10 });
                    //@ts-ignore
                    this._jsonHoveredIndex = null;
                    if (! this.jsonShowMarkers) {
                      this.hideMarkersForJsonSegment(idx);
                    }
                  });
                })(segIndex, segPaused);
                poly.addTo(window.mainmap);
                segIndex++;
                // start new segment
                currentSegPts = [{ lat: Number(point.lat), lon: Number(point.lon), raw: point }];
                currentPaused = paused;
              }
            }
            // finalize last
            if (currentSegPts.length > 0) {
              const latlngs: any[] = [];
              const pts: any[] = [];
              for (const p of currentSegPts) { latlngs.push([p.lat, p.lon]); pts.push(p); }
              const color = (currentPaused === 0) ? this.getColorHex(this.jsonColorMoving) || this.track.gpsTrack.color : this.getColorHex(this.jsonColorPaused) || this.track.gpsTrack.color;
              const poly: any = L.polyline(latlngs, { color: color, weight: 10, opacity: 0.9 });
              //@ts-ignore
              this._jsonPolylines.push(poly);
              //@ts-ignore
              this._jsonPoints.push(pts);
              //@ts-ignore
              this._jsonMarkers.push([]);
              const segPaused2 = currentPaused;
              ((idx, segPausedLocal) => {
                poly.on('mouseover', (e: any) => {
                  poly.setStyle({ color: this.getColorHex(this.jsonColorHover) || this.track.gpsTrack.color, weight: 10 });
                  //@ts-ignore
                  this._jsonHoveredIndex = idx;
                });
                poly.on('mouseout', (e: any) => {
                  poly.setStyle({ color: (segPausedLocal === 0) ? (this.getColorHex(this.jsonColorMoving) || this.track.gpsTrack.color) : (this.getColorHex(this.jsonColorPaused) || this.track.gpsTrack.color), weight: 10 });
                  //@ts-ignore
                  this._jsonHoveredIndex = null;
                  if (! this.jsonShowMarkers) {
                    this.hideMarkersForJsonSegment(idx);
                  }
                });
              })(segIndex, segPaused2);
              poly.addTo(window.mainmap);
            }
        },
        showMarkersForJsonSegment(idx: number) {
            //@ts-ignore
            const pts = this._jsonPoints && this._jsonPoints[idx];
            if (! pts) { return; }
            //@ts-ignore
            const existing = this._jsonMarkers && this._jsonMarkers[idx];
            if (existing && existing.length > 0) {
              for (const m of existing) {
                try { if (!m._map) { m.addTo(window.mainmap); } } catch (e) {}
              }
              return;
            }
            const markers: any[] = [];
            const baseColor = this.getColorHex(this.jsonMarkerColor) || this.track.gpsTrack.color;
            for (let i = 0; i < pts.length; i++) {
              const p = pts[i];
              const m = L.circleMarker([p.lat, p.lon], { radius: 5, color: baseColor, fillColor: baseColor, fillOpacity: 1 });
              // attach segment index
              // @ts-ignore
              m._jsonSegmentIdx = idx;
              try {
                const raw = p.raw;
                const timeStr = this.formatLocalTime(raw && raw.timestamp);
                const hr = (raw && raw.hr !== undefined && raw.hr !== null) ? raw.hr : '-';
                const cad = (raw && raw.cad !== undefined && raw.cad !== null) ? raw.cad : '-';
                const power = (raw && raw.pwr !== undefined && raw.pwr !== null) ? raw.pwr : '-';
                let speedText = '-';
                if (raw && raw.gpsSpd !== undefined && raw.gpsSpd !== null && !isNaN(raw.gpsSpd)) {
                  speedText = (Number(raw.gpsSpd) * 3.6).toFixed(1) + ' km/h';
                } else {
                  if (i > 0) {
                    const prev = pts[i - 1];
                    if (prev && prev.raw && prev.raw.timestamp && raw && raw.timestamp) {
                      const t1 = new Date(prev.raw.timestamp).getTime();
                      const t2 = new Date(raw.timestamp).getTime();
                      const dt = (t2 - t1) / 1000.0;
                      if (dt > 0) {
                        const dist = distanceBetweenPoints(prev.lat, prev.lon, p.lat, p.lon);
                        const speedMps = dist / dt;
                        speedText = (speedMps * 3.6).toFixed(1) + ' km/h';
                      }
                    }
                  }
                }
                const pausedText = (raw && raw.paused !== undefined && raw.paused !== null) ? raw.paused : '-';
                const content = `<div style="font-size:12px; line-height:1.2">` +
                  `<div>Czas: <b>${timeStr}</b></div>` +
                  `<div>Tętno: <b>${hr}</b></div>` +
                  `<div>Kad: <b>${cad}</b></div>` +
                  `<div>Moc: <b>${power}</b></div>` +
                  `<div>Prędkość: <b>${speedText}</b></div>` +
                  `<div>Paused: <b>${pausedText}</b></div>` +
                  `</div>`;
                m.bindTooltip(content, { direction: 'top', offset: [0, -8], opacity: 0.95 });
                // @ts-ignore
                m._jsonTooltipBound = true;
              } catch (e) {
                debugLog(e);
              }
              m.on('mouseover', (e: any) => {
                try { m.openTooltip(); } catch (e) {}
                try {
                  // @ts-ignore
                  const segIdx = m._jsonSegmentIdx;
                  if (segIdx !== null && segIdx !== undefined && this._jsonPolylines && this._jsonPolylines[segIdx]) {
                    this._jsonPolylines[segIdx].setStyle({ color: this.getColorHex(this.jsonColorHover) || this.track.gpsTrack.color, weight: 10 });
                    // @ts-ignore
                    this._jsonHoveredIndex = segIdx;
                  }
                } catch (e) {}
              });
              m.on('mouseout', (e: any) => {
                try { m.closeTooltip(); } catch (e) {}
                try {
                  // @ts-ignore
                  const segIdx = m._jsonSegmentIdx;
                  if (segIdx !== null && segIdx !== undefined && this._jsonPolylines && this._jsonPolylines[segIdx]) {
                    if (this._jsonHoveredIndex === segIdx) {
                      // restore to segment base color according to its paused flag
                      const ptsArr = this._jsonPoints[segIdx];
                      const basePaused = ptsArr && ptsArr[0] && ptsArr[0].raw && ptsArr[0].raw.paused !== undefined ? Number(ptsArr[0].raw.paused) : 0;
                      const baseColor = (basePaused === 0) ? (this.getColorHex(this.jsonColorMoving) || this.track.gpsTrack.color) : (this.getColorHex(this.jsonColorPaused) || this.track.gpsTrack.color);
                      this._jsonPolylines[segIdx].setStyle({ color: baseColor, weight: 10 });
                      // @ts-ignore
                      this._jsonHoveredIndex = null;
                    }
                  }
                } catch (e) {}
              });
              m.addTo(window.mainmap);
              markers.push(m);
            }
            //@ts-ignore
            this._jsonMarkers[idx] = markers;
        },
        hideMarkersForJsonSegment(idx: number) {
            //@ts-ignore
            const markers = this._jsonMarkers && this._jsonMarkers[idx];
            if (! markers) { return; }
            for (const m of markers) {
              try { m.removeFrom(window.mainmap); } catch (e) {}
            }
        },
        hideJSONSegments() {
            //@ts-ignore
            if (this._jsonPolylines) {
              for (const pl of this._jsonPolylines) {
                try { pl.removeFrom(window.mainmap); } catch (e) {}
              }
            }
            //@ts-ignore
            if (this._jsonMarkers) {
              for (const list of this._jsonMarkers) {
                for (const m of list) {
                  try { m.removeFrom(window.mainmap); } catch (e) {}
                }
              }
            }
            //@ts-ignore
            this._jsonPolylines = [];
            //@ts-ignore
            this._jsonMarkers = [];
            //@ts-ignore
            this._jsonPoints = [];
            //@ts-ignore
            this._jsonHoveredIndex = null;
            this.jsonVisible = false;
        },
    },
    props: {
        track: { required: true,
            type: Object as PropType<Track>
        }
    },
    watch: {
        "$store.state.speedThresholds": [{
            handler: "onSpeedScaleChooseChange"
        }],
        "track.maximized": [{
            handler: "onMaximizeChanged"
        }]
      ,
      gpxColor1: [{
        handler(newVal: any) {
          //@ts-ignore
          if (this._gpxPolylines) {
            for (const pl of this._gpxPolylines) {
              pl.setStyle({ color: this.getColorHex(newVal) });
            }
          }
        }
      }],
      gpxColor3: [{
        handler(newVal: any) {
          const hex = this.getColorHex(newVal) || this.track.gpsTrack.color;
          //@ts-ignore
          if (this._gpxMarkers) {
            for (const list of this._gpxMarkers) {
              for (const m of list) {
                try { m.setStyle({ color: hex, fillColor: hex }); } catch (e) {}
              }
            }
          }
        }
      }],
      gpxShowMarkers: [{
        handler(newVal: boolean) {
          //@ts-ignore
          const pointsArr = this._gpxPoints || [];
          for (let idx = 0; idx < pointsArr.length; idx++) {
            if (newVal) {
              this.showMarkersForSegment(idx);
            } else {
              this.hideMarkersForSegment(idx);
            }
          }
        }
      }]
      ,
      jsonColorMoving: [{
        handler(newVal: any) {
          //@ts-ignore
          if (this._jsonPolylines && this._jsonPoints) {
            for (let i = 0; i < this._jsonPolylines.length; i++) {
              try {
                const pts = this._jsonPoints[i];
                const pausedVal = pts && pts[0] && pts[0].raw && pts[0].raw.paused !== undefined ? Number(pts[0].raw.paused) : 0;
                if (pausedVal === 0) {
                  this._jsonPolylines[i].setStyle({ color: this.getColorHex(newVal) });
                }
              } catch (e) {}
            }
          }
        }
      }],
      jsonColorPaused: [{
        handler(newVal: any) {
          //@ts-ignore
          if (this._jsonPolylines && this._jsonPoints) {
            for (let i = 0; i < this._jsonPolylines.length; i++) {
              try {
                const pts = this._jsonPoints[i];
                const pausedVal = pts && pts[0] && pts[0].raw && pts[0].raw.paused !== undefined ? Number(pts[0].raw.paused) : 0;
                if (pausedVal !== 0) {
                  this._jsonPolylines[i].setStyle({ color: this.getColorHex(newVal) });
                }
              } catch (e) {}
            }
          }
        }
      }],
      jsonColorHover: [{
        handler(newVal: any) {
          const hex = this.getColorHex(newVal) || this.track.gpsTrack.color;
          //@ts-ignore
          if (this._jsonHoveredIndex !== null && this._jsonPolylines && this._jsonPolylines[this._jsonHoveredIndex]) {
            try { this._jsonPolylines[this._jsonHoveredIndex].setStyle({ color: hex }); } catch (e) {}
          }
        }
      }],
      jsonMarkerColor: [{
        handler(newVal: any) {
          const hex = this.getColorHex(newVal) || this.track.gpsTrack.color;
          //@ts-ignore
          if (this._jsonMarkers) {
            for (const list of this._jsonMarkers) {
              for (const m of list) {
                try { m.setStyle({ color: hex, fillColor: hex }); } catch (e) {}
              }
            }
          }
        }
      }],
      jsonShowMarkers: [{
        handler(newVal: boolean) {
          //@ts-ignore
          const pointsArr = this._jsonPoints || [];
          for (let idx = 0; idx < pointsArr.length; idx++) {
            if (newVal) {
              this.showMarkersForJsonSegment(idx);
            } else {
              this.hideMarkersForJsonSegment(idx);
            }
          }
        }
      }]
    }
})


</script>

<style>
.detailsWindow {
  position: fixed;
  z-index: 1000000;
}

.detailsWindowHeader {
  cursor: move;
}
</style>